import type { SVGProps } from 'react'

const ProactiveMarketIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <ellipse cx="30" cy="30" rx="30" ry="30" fill="currentColor" />
    <path
      d="M15.292 20.168V27.918H23.042"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.708 40.832V33.082H35.958"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.4666 26.6258C39.8115 24.7746 38.6981 23.1195 37.2303 21.8149C35.7626 20.5104 33.9883 19.5989 32.073 19.1655C30.1576 18.7322 28.1638 18.791 26.2774 19.3367C24.391 19.8823 22.6735 20.8969 21.2853 22.2859L15.292 27.9175M43.7087 33.0842L37.7153 38.7159C36.3271 40.1048 34.6097 41.1194 32.7233 41.665C30.8369 42.2107 28.843 42.2695 26.9277 41.8362C25.0124 41.4028 23.2381 40.4913 21.7703 39.1868C20.3025 37.8822 19.1892 36.2271 18.5341 34.3758"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ProactiveMarketIcon
